import { styled } from '@linaria/react';
import { colors, fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  font-family: ${fonts.body};
  color: ${semantic.text.primary};
  font-size: ${fonts.size.md};
  line-height: ${primitives.typography.lineHeight.loose};

  p,
  blockquote,
  ul,
  ol,
  dl,
  table,
  pre {
    margin-top: 0;
    margin-bottom: ${space['space-400']};
  }

  > *:last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3 {
    margin-top: ${space['space-600']};
    margin-bottom: ${space['space-400']};
    font-weight: ${fonts.weight.medium};
    line-height: ${primitives.typography.lineHeight.snug};
    border-bottom: 1px solid ${semantic.border.subtle};
    padding-bottom: 0.3em;
  }

  h1 {
    font-size: 1.6em;
  }

  h2 {
    font-size: 1.4em;
  }

  h3 {
    font-size: 1.2em;
  }

  ul,
  ol {
    padding-left: 1.2em;
  }

  blockquote {
    margin-left: 0;
    padding: 0 1em;
    color: ${semantic.text.secondary};
    border-left: 0.25em solid ${semantic.border.default};

    & > :first-child {
      margin-top: 0;
    }

    & > :last-child {
      margin-bottom: 0;
    }
  }

  code {
    padding: 0.2em 0;
    margin: 0;
    font-size: 90%;
    background-color: ${semantic.bg.surfaceSubtle};
    border-radius: ${size.radius['radius-xs']};

    &::before,
    &::after {
      letter-spacing: -0.2em;
      content: ' ';
    }
  }

  pre {
    padding: ${space['space-400']};
    overflow: auto;
    font-size: 85%;
    line-height: ${primitives.typography.lineHeight.normal};
    background-color: ${semantic.bg.surfaceSubtle};
    border-radius: ${size.radius['radius-xs']};

    code {
      background-color: transparent;
      padding: 0;

      &::before,
      &::after {
        content: none;
      }
    }
  }

  a {
    color: ${colors.primary};
    text-decoration: underline;

    &:hover {
      opacity: 0.85;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: ${space['space-200']} ${space['space-300']};
      border: 1px solid ${semantic.border.default};
      text-align: left;
    }

    th {
      background-color: ${semantic.bg.surfaceSubtle};
      font-weight: ${fonts.weight.semiBold};
    }
  }
`;
